import {
	updateCurrentPlanStartDate,
	updateEmailId,
	updateFirstName,
	updateIsAuthenticated,
	updateLastName,
	updatePhoneNumber,
	updatePlanTierId,
	updateProfileURL,
	updateStripeCustomerId,
	updateUserId,
} from '../store/userDetailsSlice';
import { useDispatch, useSelector } from 'react-redux';

import { LOCAL_BASE_URL } from '../constants/constants';
import axiosRequestInterceptor from '../interceptor/axiosAPIRequestInterceptor';
import { logger } from '../utils/logger';
import { useState } from 'react';

export const useLogin = () => {
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	const dispatch = useDispatch();

	const handleLogin = async () => {
		setLoading(true);
		setError(null);

		try {
			const response = await axiosRequestInterceptor.post(`/users/login`, {
				email: email,
				password: password,
			});

			const data = response.data;

			if (response.status === 200) {
				dispatch(updateIsAuthenticated(true));
				dispatch(updateFirstName(data.firstName));
				dispatch(updateLastName(data.lastName));
				dispatch(updateEmailId(data.email));
				dispatch(updatePhoneNumber(data.phoneNumber));
				dispatch(updatePlanTierId(data.TIER_ID));
				dispatch(updateCurrentPlanStartDate(data.currentPlanStartDate));
				dispatch(updateUserId(data.userId));
				dispatch(updateStripeCustomerId(data.stripeCustomerId));
				dispatch(updateProfileURL(data.PROFILE_URL));

				// localStorage.setItem('token', data.token);
				// You might want to return the success status
				logger.log('Login successful. printing data for user:', data);
				return true;
			} else {
				setError(data.message || 'Login failed');
				return false;
			}
		} catch (error) {
			setError(
				error?.response?.data?.errors[0]?.message || 'Login failed. Please try again.'
			);
			return false;
		} finally {
			setLoading(false);
		}
	};

	return {
		email,
		setEmail,
		password,
		setPassword,
		loading,
		error,
		handleLogin,
	};
};
